import script from "./RenewalAdvertisementForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RenewalAdvertisementForm.vue?vue&type=script&setup=true&lang=js"

import "./RenewalAdvertisementForm.vue?vue&type=style&index=0&id=26e8e048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26e8e048"]])

export default __exports__